/**
 * brownie-coffee-landing.js
 * Migrado desde el módulo PrestaShop brownielandingcoffee
 * Gestiona: detalles de tienda, menú/carta, marquee, back-to-top, formulario email
 */

(function () {
  'use strict';

  // ---------------------------------------------------------------
  // Textos (hardcoded ES — ajustar si se necesitan traducciones)
  // ---------------------------------------------------------------
  const HIDE_DETAILS_TEXT = 'HIDE DETAILS';
  const SHOW_DETAILS_TEXT = 'SHOW DETAILS';
  const EMAIL_ERROR_TEXT  = 'Enter a valid email address';

  // ---------------------------------------------------------------
  // Helpers
  // ---------------------------------------------------------------
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }

  function $$(selector, context) {
    return Array.prototype.slice.call(
      (context || document).querySelectorAll(selector)
    );
  }

  // ---------------------------------------------------------------
  // Sección Locations — toggle detalles Hermosilla
  // ---------------------------------------------------------------
  function openDetails() {
    const name     = $('.text-hermosilla-mobile');
    const btn      = $('#btn-details-hermosilla');
    const origins  = $$('.hermo-origin');
    const details1 = $$('.hermo-details1');
    const details2 = $$('.hermo-details2');

    if (name) name.style.transform = 'translateY(-75px)';

    if (btn) {
      btn.style.transform = 'translateY(60px)';
      btn.textContent     = HIDE_DETAILS_TEXT;
      btn.setAttribute('onclick', 'brownieCoffeeLanding.closeDetails()');
    }

    origins.forEach(function (el)  { el.style.display = 'none'; });
    details1.forEach(function (el) { el.style.display = 'block'; });
    details2.forEach(function (el) { el.style.display = 'block'; });
  }

  function closeDetails() {
    const name     = $('.text-hermosilla-mobile');
    const btn      = $('#btn-details-hermosilla');
    const origins  = $$('.hermo-origin');
    const details1 = $$('.hermo-details1');
    const details2 = $$('.hermo-details2');

    if (name) name.style.transform = '';

    if (btn) {
      btn.style.transform = '';
      btn.textContent     = SHOW_DETAILS_TEXT;
      btn.setAttribute('onclick', 'brownieCoffeeLanding.openDetails()');
    }

    origins.forEach(function (el)  { el.style.display = ''; });
    details1.forEach(function (el) { el.style.display = 'none'; });
    details2.forEach(function (el) { el.style.display = 'none'; });
  }

  // ---------------------------------------------------------------
  // Menú / Carta
  // ---------------------------------------------------------------
  const CATEGORY_IDS = ['coffee', 'drinks', 'specials', 'bakery', 'sandwiches'];

  function openCarta(num) {
    const cartaMenu  = $('#carta-menu');
    const backBtns   = $$('.btn-back-carta');
    const menuDesc   = $('.bc-menu-desc');
    const allItems   = $$('.bc-menu-items');
    const targetId   = 'descripcion-' + CATEGORY_IDS[num - 1];
    const target     = document.getElementById(targetId);

    if (cartaMenu) cartaMenu.style.display = 'none';
    if (menuDesc)  menuDesc.style.display  = 'flex';

    backBtns.forEach(function (el) { el.style.display = 'flex'; });
    allItems.forEach(function (el) { el.style.display = 'none'; });

    if (target) target.style.display = 'flex';
  }

  function closeCarta() {
    const cartaMenu = $('#carta-menu');
    const backBtns  = $$('.btn-back-carta');
    const menuDesc  = $('.bc-menu-desc');
    const allItems  = $$('.bc-menu-items');

    if (cartaMenu) cartaMenu.style.display = '';
    if (menuDesc)  menuDesc.style.display  = 'none';

    backBtns.forEach(function (el) { el.style.display = 'none'; });
    allItems.forEach(function (el) { el.style.display = 'none'; });
  }

  // ---------------------------------------------------------------
  // Marquee
  // ---------------------------------------------------------------
  function initMarquee() {
    const list = document.getElementById('listCoffee');
    if (!list) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let offset = 0;

    function tick() {
      const items = list.querySelectorAll('.bc-marquee__item');
      if (!items.length) return;

      const firstItem  = items[0];
      const itemWidth  = firstItem.offsetWidth;

      offset += 0.7;

      if (offset >= itemWidth) {
        offset = 0;
        list.appendChild(firstItem);
      }

      list.style.transform = 'translateX(-' + offset + 'px)';
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  // ---------------------------------------------------------------
  // Back-to-top
  // ---------------------------------------------------------------
  function initBackToTop() {
    const btn = document.getElementById('toTop');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 300) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ---------------------------------------------------------------
  // Formulario email / newsletter
  // ---------------------------------------------------------------
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  function submitEmail() {
    const emailInput = document.getElementById('email-coffee');
    const form       = document.getElementById('form-email-coffee');
    const thanks     = $('.bc-thanks');

    if (!emailInput || !isValidEmail(emailInput.value)) {
      alert(EMAIL_ERROR_TEXT);
      return;
    }

    if (form)   form.style.display   = 'none';
    if (thanks) thanks.style.display = 'block';
  }

  function initEmailForm() {
    const form = document.getElementById('form-email-coffee');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitEmail();
    });
  }

  // ---------------------------------------------------------------
  // Imagen de detalles: cambiar src según viewport
  // ---------------------------------------------------------------
  function initDetailsImage() {
    const detailsImg = $('.hermo-details1[data-desktop]');
    if (!detailsImg) return;

    function updateSrc() {
      if (window.innerWidth >= 768) {
        detailsImg.src = detailsImg.dataset.desktop;
      } else {
        detailsImg.src = detailsImg.getAttribute('src').replace('-desktop', '-mobile');
      }
    }

    window.addEventListener('resize', updateSrc, { passive: true });
  }

  // ---------------------------------------------------------------
  // Smooth scroll para los enlaces de las navs
  // ---------------------------------------------------------------
  function initSmoothScroll() {
    const navLinks = document.querySelectorAll('.bc-nav-fixed a[href^="#"], .bc-nav-desktop a[href^="#"]');

    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const targetId = link.getAttribute('href').slice(1);
        const target   = document.getElementById(targetId);
        if (!target) return;

        e.preventDefault();

        const navFixed  = document.querySelector('.bc-nav-fixed');
        const navOffset = navFixed ? navFixed.offsetHeight : 0;
        const top       = target.getBoundingClientRect().top + window.scrollY - navOffset;

        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  // ---------------------------------------------------------------
  // Init
  // ---------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function () {
    initMarquee();
    initBackToTop();
    initEmailForm();
    initDetailsImage();
    initSmoothScroll();
  });

  // API pública (usada desde los onclick del HTML)
  window.brownieCoffeeLanding = {
    openDetails:  openDetails,
    closeDetails: closeDetails,
    openCarta:    openCarta,
    closeCarta:   closeCarta,
    submitEmail:  submitEmail
  };

})();
